import Vue from 'vue';
import Router from 'vue-router';
import paths from './routers';
import NProgress from 'nprogress';
import { getToken } from '@/libs/util';
import 'nprogress/nprogress.css';
import store from '@/store';
import { hasOneOf } from '@/libs/tools';

Vue.use(Router);

const originalPush = Router.prototype.push;
const originalReplace = Router.prototype.replace;
// push
Router.prototype.push = function push (location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch(err => err);
};
// replace
Router.prototype.replace = function push (location, onResolve, onReject) {
  if (onResolve || onReject) return originalReplace.call(this, location, onResolve, onReject);
  return originalReplace.call(this, location).catch(err => err);
};

const router = new Router({
  base: '/',
  mode: 'history',
  linkActiveClass: 'active',
  routes: paths
});

const LOGIN_PAGE_NAME = 'Login';

/**
 * @param {*} access 用户权限数组，如 ['super_admin', 'admin']
 * @param {*} route 路由列表
 */
const hasAccess = (access, route) => {
  if (route.meta && route.meta.access) return hasOneOf(access, route.meta.access);
  else return true;
};

const canTurnTo = (name, access, routes) => {
  const routePermissionJudge = (list) => {
    return list.some(item => {
      if (item.items && item.items.length) {
        return routePermissionJudge(item.items);
      } else if (item.name === name) {
        return hasAccess(access, item);
      }
    });
  };
  return routePermissionJudge(routes);
};

// router gards
router.beforeEach((to, from, next) => {
  NProgress.start();
  const token = getToken();
  if (!token && to.name !== LOGIN_PAGE_NAME) {
    next({ name: LOGIN_PAGE_NAME });
  } else if (!token && to.name === LOGIN_PAGE_NAME) {
    next();
  } else if (token && to.name === LOGIN_PAGE_NAME) {
    next({ name: 'Home' });
  } else {
    store.dispatch('getUserInfo').then(user => {
      // 拉取用户信息，通过用户权限和跳转的页面的name来判断是否有权限访问;access必须是一个数组，如：['super_admin'] ['super_admin', 'admin']
      if (canTurnTo(to.name, user.access, paths)) next(); // 有权限，可访问
      else next({ replace: true, name: 'AccessDenied' }); // 无权限，重定向到401页面
    });
  }
  next();
});

router.afterEach((to, from) => {
  // ...
  NProgress.done();
});

export default router;
